import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionEyebrow = ({ num, label }) => (
  <div className="flex items-center gap-3">
    <span className="h-px w-10 bg-[#D65BB4]" />
    <span className="text-xs tracking-[0.35em] text-white/50 uppercase font-semibold">
      {num} — {label}
    </span>
  </div>
);

export default Reveal;
